module.exports = __webpack_public_path__ + "media/images/emblems/Recherswil-blason-1b4892b59dfa3a9b37924a2d15b53b0b.png";